import { Box } from "@mui/material";
import PropTypes from "prop-types";
import StatusChip from "../../../reusableComponents/status/StatusChip";

export default function BulkActions({selectedCount, onClickAction, canUpdate, availableStatuses = []}) {
    if (selectedCount === 0) return null;
    
    return {
        label: `${selectedCount} file(s) selected`,
        actions: (
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <StatusChip
                    status="update_status"
                    label="Update Status "
                    clickable={canUpdate}
                    onStatusChange={onClickAction}
                    availableStatuses={availableStatuses}
                    chipBorderRadius="8px"
                    chipHeight="30px"
                />
            </Box>
        ),
    };
}

BulkActions.propTypes = {
    selectedCount: PropTypes.number.isRequired,
    onClickAction: PropTypes.func.isRequired,
    canUpdate: PropTypes.bool.isRequired,
    availableStatuses: PropTypes.arrayOf(PropTypes.string)
};